query GetAccount($id: ID!) {
  account(id: $id) {
    id
    insertedAt
    updatedAt
    customerId
    deactivatedAt
    activeAt
    expireAt
    defaultExpiresIn
    defaultAutoResponse {
      id
    }
    name

    notes
    lrnAccess
    smsAccess
    mmsAccess
    byonAccess
    requireIpApiAccess
    requireIpGqlAccess

    maxDids

    overrideByonAccess
    overrideMaxSubAccounts
    overrideMaxDids
    overrideLegacyAccess
    overrideLrnAccess
    overrideSmsAccess
    overrideMmsAccess
    overrideRequireIpApiAccess
    overrideRequireIpGqlAccess
    overrideRequireDidGroupSmsAccess
    overrideRequireDidGroupMmsAccess
    overrideRequireDidGroupApproval

    supportPlan {
      id
      name
      notes
      insertedAt
      updatedAt
    }

    # coveragePlan {
    #   id
    #   name
    #   notes
    #   insertedAt
    #   updatedAt
    #   unlistedCountrySmsAccess
    #   unlistedCountryMmsAccess
    # }

    # maxSubAccounts
    legacyAccess
    id
    name

    servicePlan {
      id
      name
      # maxSubAccounts
    }
    parentAccount {
      id
      name
    }
  }
}
